var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalka(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0302 7.96934C18.1706 8.10997 18.2495 8.30059 18.2495 8.49934C18.2495 8.69809 18.1706 8.88871 18.0302 9.02934L11.0302 16.0293C10.8895 16.1698 10.6989 16.2487 10.5002 16.2487C10.3014 16.2487 10.1108 16.1698 9.97015 16.0293L5.97015 12.0293C5.89647 11.9607 5.83736 11.8779 5.79637 11.7859C5.75538 11.6939 5.73334 11.5946 5.73156 11.4939C5.72979 11.3932 5.74831 11.2931 5.78603 11.1997C5.82375 11.1064 5.8799 11.0215 5.95112 10.9503C6.02233 10.8791 6.10717 10.8229 6.20056 10.7852C6.29394 10.7475 6.39397 10.729 6.49468 10.7307C6.59538 10.7325 6.69469 10.7546 6.78669 10.7956C6.87869 10.8366 6.96149 10.8957 7.03015 10.9693L10.5002 14.4393L16.9702 7.96934C17.1108 7.82889 17.3014 7.75 17.5002 7.75C17.6989 7.75 17.8895 7.82889 18.0302 7.96934Z",
    fill: "#004529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalka);
export default __webpack_public_path__ + "static/media/galka.ec29754299e43afd375be2bb36e9f98b.svg";
export { ForwardRef as ReactComponent };